/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber17Small = createReactComponent("outline", "number-17-small", "IconNumber17Small", [["path", { "d": "M7 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M13 8h4l-2 8", "key": "svg-1" }]]);

export { IconNumber17Small as default };
//# sourceMappingURL=IconNumber17Small.mjs.map
